import { GetDriveTimePolygonsRequest, GetDriveTimePolygonsResponse } from 'src/common-services/types/drive-time-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class DriveTimeClient extends BaseClient {
  getDriveTimePolygons(request: GetDriveTimePolygonsRequest): Promise<GetDriveTimePolygonsResponse> {
    return this.call<GetDriveTimePolygonsResponse>('/drive-times', 'POST', {
      data: request,
    })
  }
}
